import { Box, Typography } from '@mui/material';
import { SavedHomeDesigns } from '../../../../models/homes.models.tsx';
import { ResultHomeModels } from '../../../../possibly-stateful-components/Results/ResultHomeModels.tsx';

interface SavedHomeDesignsResultListProps {
  homeDesigns: SavedHomeDesigns[] | undefined;
}

export const SavedHomeDesignsResultList = ({
  homeDesigns,
}: SavedHomeDesignsResultListProps) => {
  return (
    <Box>
      {homeDesigns && homeDesigns?.length > 0 ? (
        <>
          <Typography variant="h1" className="header" data-home-page-title>
            Saved Home Designs
          </Typography>
          <Box className="results-list">
            {homeDesigns.map((result) => {
              return (
                <Box key={result.homeModelId} sx={{ maxWidth: '350px' }}>
                  {result && (
                    <ResultHomeModels
                      customizationQuery={result.customizationQuery}
                      homeModelFavorites={homeDesigns}
                      result={result.selectedProducts[0]}
                    />
                  )}
                </Box>
              );
            })}
          </Box>
        </>
      ) : null}
    </Box>
  );
};
